const pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"xp-full-height\"\u003EOoops! It looks like the requested report does not exist.\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;